var $ = global.jQuery = global.$;

var Slider = require('./Slider');
/**
 * Hero Slider widget. Extends Slider widget with some different widget options
 * @class
 * @extends Slider
 */

var ContentSlider_PTS = Slider.extend(
  /** @lends HeroSlider.prototype */
  {
    /**
     * Initialisation method
     * @private
     */
    init: function() {

      var self = this;


      this.$arrowContainer = $('[data-slider-nav]');

      this.widgetOptions.responsive = false;
      this.widgetOptions.autoplay = true;
      this.widgetOptions.arrows = false;
      this.widgetOptions.dots = true;

      this._super();
    }
  });

module.exports = ContentSlider_PTS;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/ContentSlider_PTS.js
// module id = 339
// module chunks = 1